import { useSale } from "../../../contexts/SaleContext"
import React from "react"
import { DatePicker, TimeRangePickerProps } from "antd"
import ES from 'antd/es/date-picker/locale/es_ES';
import { useConfig } from "../../../contexts/ConfigContext"
import { useCompany } from "../../../contexts/CompanyContext"
import { saleStatus } from "../../../config/const"
import dayjs from "dayjs";
import { useSecureRequest } from "../../../hooks/useSecureRequest";

const { RangePicker } = DatePicker;

function DateTimePicker(props:any){
  const { sale,updateSale} = useSale()
  const {config} = useConfig()
  const {company} = useCompany()
  const {securePost} = useSecureRequest()
  const onChange: TimeRangePickerProps["onChange"] = (dates, dateStrings) => {
    (async () => { 
      if(dates){
        console.log('Consulta por rango: ',dateStrings)
        props.setSpinning(true)
        const saleResponse = await securePost('/inventory/movement/get-movements',{
          company: company.current.uid,
          status: saleStatus.COMPLETED,
          documentType: "SALE_INVOICE",
          module: config.module,
          filter: {
            startDate: dates[0] ? dates[0].startOf('day').valueOf() : undefined,
            endDate: dates[1] ? dates[1].endOf('day').valueOf() : undefined,
          }
        })
        props.setSpinning(false)
        if(saleResponse.status === 200){
          console.log("Bills",saleResponse.movementList)
          updateSale({billList: saleResponse.movementList,datePickerFilter:dateStrings})
        }else{
          alert("Ha ocurrido un error, por favor recargue la página e intente de nuevo")
        }
      }
    })()
  }
  const rangePresets: TimeRangePickerProps['presets'] = [
    { label: 'Hoy', value: [dayjs().startOf('day'), dayjs().endOf('day')] },
    { label: 'Últimos 7 días', value: [dayjs().subtract(6, 'day').startOf('day'), dayjs().endOf('day')] },
    { label: 'Últimos 14 días', value: [dayjs().subtract(13, 'day').startOf('day'), dayjs().endOf('day')] },
    { label: 'Últimos 30 días', value: [dayjs().subtract(29, 'day').startOf('day'), dayjs().endOf('day')] },
    { label: 'Últimos 90 días', value: [dayjs().subtract(89, 'day').startOf('day'), dayjs().endOf('day')] },
  ];
  const start = sale.datePickerFilter?.[0] ? dayjs(sale.datePickerFilter[0]) : dayjs().startOf('day')
  const end = sale.datePickerFilter?.[1] ? dayjs(sale.datePickerFilter[1]) : dayjs().endOf('day')
  return( <RangePicker style={{flex:1}}
      presets={rangePresets}
      format="YYYY/MM/DD"
      defaultValue={[start,end]}
      locale={ES} onChange={onChange}
    />
  )
}

export default DateTimePicker
